import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { separateCoordinates } from '@shared/utils/functions/separate-coordinates';
import { AbstractAforoSensorDataSource } from '@types-custom/models/ui/modal-aforo-model';
import { map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AforoService implements AbstractAforoSensorDataSource {

  private baseURL = this.environment.camerasUrl;

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) { }

  public getLayerAforoGeoJson(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.baseURL}/camera/format-geo-json?recordsPerPage=1000&page=0&state=ACTIVO&cameraType=EXT`
      // `${this.baseURL}/camera/format-geo-json?recordsPerPage=1000&page=0&state=ACTIVO`
      // `assets/mock/aforo-layer-mock.json`
    );
  }

  public getPanelAforoMeasurements(): Observable<any> {
    return this.httpClient.get<any[]>(
      `${this.baseURL}/capacity/panel-data`

      // `${this.baseURL}/camera-history/report/count-and-speed-vehicles-global`
      // `assets/mock/aforo-history.json`
    );

  }

  getModalAforoMeasurements(sensorId: string): Observable<any> {
    return this.httpClient.get<any[]>(
      `${this.baseURL}/capacity/modal-data/${sensorId}`
      // `assets/mock/aforo-modal-v4.json`
    );
  }

  getAforoMapper(AforoObj: any) {
    return separateCoordinates(AforoObj.geoAforo);
  }

  getImageModal(idCamera: any) {
    return this.httpClient.get<any[]>(
      `${this.baseURL}/capacity/camera-image/${idCamera}`
      // `assets/mock/aforo-modal-v4.json`
    );
  }

  getCameraInfoByName(name: string) {
    return this.httpClient.get<any>(
      `${this.baseURL}/camera/pagination/data?page=0&recordsPerPage=1`,
      {
        params: { name }
      }
    ).pipe(
      map(response => {
        return (response && response?.records?.length) ? response.records[0] : null
      })
    );
  }
}
